import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { fetchActivitiesWithExperience } from '../../../common/utils/analytics/utils';
import { ActivityClient } from '../base';
import { fetchActivitiesV2 } from './fetch-activities';
export var ActivityClientV2 = /*#__PURE__*/function (_ActivityClient) {
  function ActivityClientV2(_product, baseUrl) {
    var _this;
    _classCallCheck(this, ActivityClientV2);
    _this = _callSuper(this, ActivityClientV2, ['v2', _product, undefined, baseUrl]);
    _defineProperty(_this, "fetchActivities", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(retryMS, filters, activityQueries) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", fetchActivitiesWithExperience(function (experience) {
                return fetchActivitiesV2({
                  experience: experience,
                  product: _this.product,
                  retryMS: retryMS,
                  filters: filters,
                  activityQueries: activityQueries,
                  baseUrl: _this.baseUrl
                });
              }, 'v2'));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "setProduct", function (product) {
      _this.product = product;
    });
    return _this;
  }
  _inherits(ActivityClientV2, _ActivityClient);
  return _createClass(ActivityClientV2);
}(ActivityClient);